import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import * as actions from '../../actions/movimientocompra';
import {api, API_URL} from '../../actions/_request';
import _ from "lodash";

const requestData = (pageSize, page, sorted, filtered,tipo_movimiento_id) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var fecha="";
        var referencia="";
        var concepto="";
        var referencia="";
        var cliente="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "referencia":
              referencia=filtered[i].value;
              break;            
            case "referencia":
              referencia=filtered[i].value;
              break;
            case "concepto":
              concepto=filtered[i].value;
              break;   
             case "cliente":
              cliente=filtered[i].value;
              break;           
          }
        }
        api().get(`/movimientocac_sustituto?filtro_sustituto=1&tipo_movimiento_id=${tipo_movimiento_id}&referencia=${referencia}&cliente=${cliente}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data.total[0].total; 
            



                  filteredData= response.data.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)




              



            }
        });
    });
};
class Clientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          modal       : false,
          prospectoid : null,
          title       : "",
          data:[],
          pages: null,
          loading: true
        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.seleccion = this.seleccion.bind(this);
    }
    seleccion(renglon){
       this.props.retorno(renglon);

    }
    fetchData(state, instance) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        requestData(
          state.pageSize,
          state.page,
          state.sorted,
          state.filtered,
          this.props.tipo_movimiento_id
        ).then(res => {
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.rows,
            pages: res.pages,
            loading: false
          });
        });
    }
    toggle(evt, prospectoid = null, title = "Agregar Usuario"){
        let {modal} = this.state;
        this.setState({
          modal       : !modal,
          prospectoid : prospectoid,
          title       : title,
        });
    }
    componentDidMount() {
        // let self = this;
        // api().get('/sat/productos_servicios/1')
        // .then(function(response)
        // {
        // if(response.status === 200)
        // {
        // self.setState({
        // data : response.data
        // });
        // }
        // });
    }
    render() {
      const { data, pages, loading } = this.state;
      return(
        <div className="view">            
          <Card>
            <CardBlock>                        
              <ReactTable
                getTrProps={(state, rowInfo, column) => {                                  
                    if(rowInfo === undefined){                                          
                      return{}
                    }else{
                      return{onDoubleClick: (evt)=>this.seleccion(rowInfo.original)}                                   
                    }
                  }
                }
                className = "-striped -highlight"
                columns   = {[
                  {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                  {Header: 'Referencia', accessor: 'referencia',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                  {Header: 'Cliente', accessor: 'cliente' ,minWidth:500, style: { 'textAlign': 'center'}}, 
                  {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                  {Header: 'Saldo', accessor: 'saldo',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                       
                ]}
                manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                data={data}
                pages={pages} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                filterable
                pageSizeOptions= {[5]}
                defaultPageSize={5} 
              />
            </CardBlock>
          </Card>           
        </div>
      );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        movimientocompra : state.movimientocompra,
    }
};

export default connect(mapStateToProps, actions)(Clientes)


// WEBPACK FOOTER //
// ./src/components/catalogos/tabla_ca_clientes_sustituto.js